import { supabase } from '../lib/supabase';

export const authService = {
  async signUp(email, password, userData) {
    try {
      // Use VITE_APP_URL for production, fallback to window.location.origin for local dev
      const baseUrl = import.meta.env.VITE_APP_URL || window.location.origin;
      const { data, error } = await supabase?.auth?.signUp({
        email,
        password,
        options: {
          data: userData,
          emailRedirectTo: `${baseUrl}/photographer-login`
        }
      });
      
      if (error) {
        // Handle specific Supabase errors
        if (error.message?.includes('Signups not allowed')) {
          throw new Error('التسجيل معطل حاليًا. يرجى التواصل مع الإدارة لتفعيل حسابك.');
        }
        if (error.message?.includes('User already registered')) {
          throw new Error('هذا البريد الإلكتروني مسجل بالفعل');
        }
        throw error;
      }
      
      return data;
    } catch (error) {
      console.error('Sign up error:', error);
      throw error;
    }
  },

  async signIn(email, password) {
    const { data, error } = await supabase?.auth?.signInWithPassword({
      email,
      password
    });
    if (error) throw error;
    return data;
  },

  async signOut() {
    const { error } = await supabase?.auth?.signOut();
    if (error) throw error;
  },

  async getCurrentUser() {
    const { data: { user }, error } = await supabase?.auth?.getUser();
    if (error) throw error;
    return user;
  },

  // SAFE: use maybeSingle() so missing profile returns null instead of throwing (avoids stuck Loading).
  // ENUM public.user_role values: 'customer' | 'photographer' | 'admin' (no 'user').
  async getUserProfile(userId) {
    const { data, error } = await supabase?.from('user_profiles')?.select('*')?.eq('id', userId)?.maybeSingle();
    if (error) throw error;
    return data ?? null;
  }
};